<template>
  <v-container>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3 >
        <h4>Create a new Enrollment</h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6 offset-sm3>
        <form action="" @submit.prevent="onCreateEnrollment">
          <v-layout row>
            <v-flex xs12 sm6>
            <v-text-field
              name="enrollmentName"
              label="Name"
              v-model="enrollmentName"
              id="enrollmentName"
              single-line
              required
            ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6>
            <v-select
              name="enrollmentPriority"
              label="Priority"
              v-model="editedEnrollmentPriority"
              :items="enrollmentPriorityHolder"
              id="enrollmentPriority"
              single-line
              required
            ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6>
              <v-btn 
              class="primary" 
              :disabled="!formIsValid"
              type="submit">
                Create Enrollment
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      enrollmentName: '',
      enrollmentPriorityHolder: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      editedEnrollmentPriority: '',
      dialog: false
    }
  },
  props: ['id'],
  computed: {
    enrollment () {
      return this.$store.getters.loadedEnrollment(this.id)
    },
    enrollments () {
      return this.$store.getters.loadedEnrollments
    },
    formIsValid () {
      return this.enrollmentName !== ''
    }
  },
  methods: {
    onCreateEnrollment () {
      if (!this.formIsValid) {
        return
      }
      const enrollmentData = {
        title: this.enrollmentName,
        enrollmentPriority: this.editedEnrollmentPriority
      }
      this.$store.dispatch('createEnrollment', enrollmentData)
      this.$router.push('/enrollments')
    }
  }
}
</script>




// WEBPACK FOOTER //
// CreateEnrollment.vue?25e57f7b